module.exports = __webpack_public_path__ + "img/chongbi.8ad05dca.png";